import React, { Component } from 'react';
import 'css/ViewBetslipItem.scss';
import classNames from 'classnames';
import { formatSpillerPlayer } from 'utils/Helper';
import { NotificationManager } from 'react-notifications';
import { oddsName } from 'utils/VirtualHelper';
import { desktopOnly } from 'utils/UiHelper';

export default class ViewBetslipItem extends Component {
    onClickRemoveBtn() {
        if (this.props.onRemoveHandler) {
            this.props.onRemoveHandler(this.props.item);
        }
    }

    showInfo(text, e) {
        NotificationManager.warning('', text, 7000);
        e.stopPropagation();
        e.preventDefault();
    }

    getEventName() {
        let item = this.props.item;
        let isCustomBet = this.props.isCustomBet;
        let customBetEventName = this.props.customBetEventName;

        return isCustomBet
            ? item.marketName
                ? item.marketName
                : 'n/a'
            : item.marketName
                ? item.marketName.split(' - ')
                : 'n/a';
    }

    render() {
        const item = this.props.item;
        const changed = this.props.changed;
        let betText = item.competitor;
        const isCustomBet = this.props.isCustomBet;
        const customBetEventName = this.props.customBetEventName;

        const tempName = item.eventName ? item.eventName.split(' - ') : '';
        let eventName = isCustomBet ? customBetEventName : item.eventName;

        let isItemError = false;

        if (this.props.itemError && this.props.itemError.length > 0) {
            this.props.itemError.map((b) => {
                if (item.eventId === b.eventId && b.error !== '') {
                    isItemError = true;
                }
                return b;
            });
        }

        const virtualSpillerPlayer = formatSpillerPlayer(
            oddsName(betText),
            tempName[0],
            tempName[1]
        );
        const regularSpillerPlayer = formatSpillerPlayer(
            betText,
            tempName[0],
            tempName[1],
            item
        );
        const text = this.props.isVirtual
            ? virtualSpillerPlayer
            : regularSpillerPlayer;

        const spillerPlayerText = isCustomBet
            ? item && item?.competitor
                ? item?.competitor
                : 'n/a'
            : item && item.eventName && tempName
                ? text
                : 'n/a';

        return (
            <section
                className={classNames('view-betslip-item', {
                    disabled: isItemError,
                    'live-disabled': this.props.isLiveBetDisabled,
                })}
            >
                {desktopOnly() ? (
                    <div className="event-name-desktop">
                        <div className="remove-btn-wrapper">
                            <div
                                className="remove-btn"
                                onClick={this.onClickRemoveBtn.bind(this)}
                            >
                                <i className="fa fa-times" aria-hidden="true" />
                            </div>
                        </div>
                        <div>{eventName}</div>
                    </div>
                ) : (
                    <h3 className="row">
                        <div className="col-8">{eventName}</div>
                        <div className="col-2">
                            <div
                                className="remove-btn"
                                onClick={this.onClickRemoveBtn.bind(this)}
                            >
                                <i className="fa fa-times" aria-hidden="true" />
                            </div>
                        </div>
                    </h3>
                )}

                <div className="team-item">
                    <div className="row">
                        <div className="col-8">
                            <div className="betslip-outcome">
                                {item.marketTypeName &&
                                    item.marketTypeName.endsWith('.Halvleg') &&
                                    `${item.marketTypeName} `}
                                {/*{item.eventName
                                    ? formatSpillerPlayer(
                                          shortHandicap(
                                              item,
                                              item.betText,
                                              false,
                                              true
                                          ),
                                          tempName[0],
                                          tempName[1]
                                      )
                                    : 'n/a aaa'}*/}
                                {this.getEventName()}
                            </div>
                            <div className="dark">
                                <b>{spillerPlayerText}</b>
                            </div>
                        </div>

                        <div className="col-2">
                            <div
                                className={classNames('odds-value', {
                                    changed:
                                        changed[item.gameId] === item.betNr,
                                })}
                            >
                                <b>{item.odds.toFixed(2)}</b>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
